import {Typography} from "@material-tailwind/react";
import {
  BuildingLibraryIcon,
  CheckIcon,
  IdentificationIcon,
  InboxArrowDownIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import {useContext, useEffect} from "react";
import {AgentRequestContext} from "../../../context/agent_context";

const steps = [
  {title: "اطلاعات هویتی", caption: "مشخصات فردی", icon: UserIcon},
  {title: "اطلاعات ارتباطی", caption: "راه‌های تماس", icon: BuildingLibraryIcon},
  {title: "رشته تخصصی", caption: "سوابق و حوزه فعالیت", icon: IdentificationIcon},
  {title: "بارگذاری مدارک", caption: "تکمیل درخواست", icon: InboxArrowDownIcon},
];

export function AgentRequestSteps() {

  const {
    activeStep,
    setActiveStep,
    setIsLastStep,
    setIsFirstStep,
    allowedStep,
  } = useContext(AgentRequestContext)

  const currentStep = Number.isInteger(activeStep) ? activeStep : 0;
  const progress = `${(Math.min(Math.max(currentStep, 0), steps.length - 1) / (steps.length - 1)) * 100}%`;

  useEffect(() => {
    setIsFirstStep(currentStep === 0);
    setIsLastStep(currentStep === steps.length - 1);
  }, [currentStep, setIsFirstStep, setIsLastStep]);

  return (
    <nav className="w-full" aria-label="مراحل درخواست همکاری">
      <div className="relative px-2" dir="rtl">
        <div className="absolute left-[12.5%] right-[12.5%] top-5 h-0.5 overflow-hidden rounded-full bg-app-border">
          <div
            className="absolute right-0 top-0 h-full rounded-full bg-app-primary transition-all duration-500"
            style={{width: progress}}
          />
        </div>

        <ol className="relative z-10 grid grid-cols-4">
          {steps.map(({title, caption, icon: Icon}, index) => {
            const isActive = currentStep === index;
            const isComplete = currentStep > index;
            const isAvailable = (allowedStep ?? 0) >= index;

            return (
              <li key={title} className="flex min-w-0 justify-center">
                <button
                  type="button"
                  disabled={!isAvailable}
                  onClick={() => isAvailable && setActiveStep(index)}
                  className={`group flex w-full min-w-0 flex-col items-center px-1 text-center outline-none ${
                    isAvailable ? "cursor-pointer" : "cursor-not-allowed"
                  }`}
                  aria-current={isActive ? "step" : undefined}
                >
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-full border-2 transition-all duration-300 ${
                      isActive
                        ? "scale-110 border-app-primary bg-app-primary text-app-on-primary shadow-lg"
                        : isComplete
                          ? "border-app-primary bg-app-primary text-app-on-primary"
                          : "border-app-border bg-app-surface text-app-text-subtle"
                    }`}
                  >
                    {isComplete ? <CheckIcon className="h-5 w-5"/> : <Icon className="h-5 w-5"/>}
                  </span>

                  <Typography
                    variant="small"
                    className={`mt-2 truncate text-[11px] font-semibold sm:text-sm ${
                      isActive || isComplete ? "text-app-text" : "text-app-text-muted"
                    }`}
                  >
                    {title}
                  </Typography>
                  <Typography className="mt-0.5 hidden text-xs text-app-text-subtle md:block">
                    {caption}
                  </Typography>
                </button>
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}
